import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetBillDetailsQuery } from "../../../services/Reports";
import {
  getBillDetailsRequest,
  getBillDetailsFailure,
  getBillDetailsSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allBillDetails,
    isLoading: billDetailsLoading,
    isError: billDetailsError,
  } = useGetBillDetailsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.billDetailsPageNo,
    pageSize: state.billDetailsPageSize,
    fromDate: new Date(state.billDetailsFromDate).toLocaleDateString(),
    toDate: new Date(state.billDetailsToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (billDetailsLoading) {
      dispatch(getBillDetailsRequest());
    }
    if (billDetailsError) {
      dispatch(getBillDetailsFailure(billDetailsError));
    }
    if (allBillDetails) {
      dispatch(
        getBillDetailsSuccess({
          data: allBillDetails.data.allbillDetails[0].data || [],
          totalPages:
            allBillDetails.data.allbillDetails[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allBillDetails,
    profileData,
    state.billDetailsFromDate,
    state.billDetailsToDate,
    state.billDetailsPageNo,
    state.billDetailsPageSize,
  ]);
  return <></>;
};
export default Content;
